import { CartItem } from "./CartItem";
import { APP_URL } from "js/common/AppUrl";
import { storage } from "storage";

class CartItemUnitary extends CartItem {
    static template(data) {
        const { product, quantity } = data;

        //Get product from storage so we have all data
        const completeProduct = storage.products.get(product.code);
        const entity = completeProduct.entity;
        const entityType = entity.entity_type;

        return `<div data-code="${
            completeProduct.code
        }" data-component="CartItemUnitary"  class="product-card">
            <li>
                <div class="wrapper-product">
                    <div class="image-container">
                        <img src="${
                            entity.image
                                ? APP_URL +
                                  "/storage/images/91x64-" +
                                  entity.image.filename
                                : ""
                        }" width="91" height="64" class="hide-onmobile"/>
                    </div>
                    <div class="product">
                        ${
                            entity.name
                                ? `<div class="title">${entityType.name} ${entity.name}</div>`
                                : ""
                        }
                        ${
                            entity.legend
                                ? `<div class="legend">${entity.legend}</div>`
                                : ""
                        }
                        ${
                            entity.brand && entity.brand.name
                                ? `<div class="brand">Marque ${entity.brand.name}</div>`
                                : ""
                        }
                        ${
                            completeProduct.reference_inintelligente
                                ? `<div class="ref">Ref. ${completeProduct.reference_inintelligente}</div>`
                                : ""
                        }
                    </div>
                </div>
                <div class="wrapper-quantity">
                    <div class="icon remove remove-mobile"></div>
                    <div class="quantity">${quantity}</div>
                </div>
            </li>
        </div>`;
    }
}

export { CartItemUnitary };
